import en from './en/index'
import cn from './cn/index'
export default {
  en,
  cn
}